import Reveal from "../components/Reveal";
import AppShotFrame from "../components/AppShotFrame";

const FEATURES = [
  {
    eyebrow: "Clients",
    title: "Everything about your client, in one place.",
    body: "Contact details, appointment history, active tasks, uploaded documents, invoices and portal access — one profile that grows with the relationship.",
    shot: "/appstore_ipad_02_clients.png",
    alt: "Client list in ClientDesk VA showing Total, Active, Pending, Inactive and Archived counts, plus searchable client rows.",
  },
  {
    eyebrow: "Scheduling & bookings",
    title: "Bookings without the ping-pong emails.",
    body: "Publish appointment types with your availability, take bookings from a public link, and confirm meeting details automatically — Google Calendar and Outlook stay in sync.",
    shot: "/appstore_ipad_03_bookings.png",
    alt: "ClientDesk VA scheduling screen with Bookings, Appointment Types, Availability, Booking Rules and Booking Links tabs.",
  },
  {
    eyebrow: "Tasks",
    title: "Never lose a follow-up again.",
    body: "Personal, team and client-linked tasks with priorities, due dates and status. Everything you owe someone, in one honest list.",
    shot: "/appstore_ipad_04_tasks.png",
    alt: "ClientDesk VA tasks screen with To Do, In Progress, Due Today, Overdue and Completed counters.",
  },
  {
    eyebrow: "Forms & onboarding",
    title: "Onboard new clients in minutes, not days.",
    body: "Intake forms, service requests, contracts and welcome documents live together. Send one link — get everything you need back, filed under the right client.",
    shot: "/appstore_ipad_05_forms.png",
    alt: "ClientDesk VA forms and documents workspace with Onboarding, Service Requests, Contracts, Invoices, Forms and Documents tabs.",
  },
  {
    eyebrow: "Calendar",
    title: "Your whole workday, one clean view.",
    body: "Month, week, day and list views. Every booking, every event, every deadline — in a calendar you actually want to open on a Monday morning.",
    shot: "/appstore_ipad_06_calendar.png",
    alt: "ClientDesk VA calendar screen showing a monthly view with Month, Week, Day and List switchers.",
  },
];

export default function FeatureShowcase() {
  return (
    <section data-testid="feature-showcase" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl mb-16">
          <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
            What's inside
          </div>
          <h2 className="font-display font-extrabold text-[32px] sm:text-[44px] leading-[1.06] tracking-[-0.02em] text-[#1A2A3A]">
            Fewer tools. More time serving clients.
          </h2>
        </Reveal>

        <div className="space-y-24 lg:space-y-32">
          {FEATURES.map((f, i) => {
            const reverse = i % 2 === 1;
            return (
              <div
                key={f.eyebrow}
                className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                  reverse ? "lg:[direction:rtl]" : ""
                }`}
              >
                <Reveal className={`${reverse ? "lg:[direction:ltr]" : ""}`}>
                  <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
                    {f.eyebrow}
                  </div>
                  <h3 className="font-display font-extrabold text-[26px] sm:text-[34px] leading-[1.1] tracking-[-0.02em] text-[#1A2A3A] mb-4">
                    {f.title}
                  </h3>
                  <p className="text-[16px] text-[#57534E] leading-relaxed">{f.body}</p>
                </Reveal>
                <Reveal delay={100} className={`${reverse ? "lg:[direction:ltr]" : ""}`}>
                  <AppShotFrame src={f.shot} alt={f.alt} variant="tablet" />
                </Reveal>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
